import { render, staticRenderFns } from "./AppointmentTimetable.vue?vue&type=template&id=1b538fed"
import script from "./AppointmentTimetable.vue?vue&type=script&lang=js"
export * from "./AppointmentTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports